import { render, staticRenderFns } from "./duoXuan.vue?vue&type=template&id=0f1a93dc&scoped=true&"
import script from "./duoXuan.vue?vue&type=script&lang=js&"
export * from "./duoXuan.vue?vue&type=script&lang=js&"
import style0 from "./duoXuan.vue?vue&type=style&index=0&id=0f1a93dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1a93dc",
  null
  
)

export default component.exports